import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { ColorPicker, } from '@tribeplatform/react-ui-kit/ColorPicker';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
export function FormColorPicker({ name, validation, label, helperText, onChange: fieldOnChange, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, defaultValue: "#FFFFFF", render: ({ field: { onChange, value }, fieldState: { error, invalid }, }) => {
            return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(ColorPicker, { invalid: invalid, color: value, onChange: value => {
                                    onChange(value);
                                    if (typeof fieldOnChange === 'function') {
                                        fieldOnChange(value);
                                    }
                                }, ...rest }, void 0), _jsx(FormControl.Meta, { ...{
                                    helperText,
                                    invalid,
                                    error: error === null || error === void 0 ? void 0 : error.message,
                                } }, void 0)] }, void 0)] }, void 0));
        } }, void 0));
}
//# sourceMappingURL=FormColorPicker.js.map